/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

/*
 * This component displays a little thumbnail of the ticket.  It
 * takes three inputs:
 *
 * o Ticket type to get the right shape
 * o Ticket color
 * o Completion status (to optionally show checkmark)
 *
 */

import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { TicketType } from '@touchplan/common';

import { TicketEditBaseComponent } from '../../../modules/ticket-edit/components/ticket-edit-base/ticket-edit-base.component';
import { Role } from '@touchplan/common';
import { EditTicketsCombined } from 'src/app/app-data/models/EditTicketsCombined';
import { CONSTRAINT_ACCEPTANCE_STATE } from '@touchplan/common';
import { colorIsDark } from 'utils';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'ticket-thumbnail',
	templateUrl: './ticket-thumbnail.component.html',
	styleUrls: ['./ticket-thumbnail.component.scss'],
	standalone: true,
	imports: [CommonModule],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TicketThumbnailComponent extends TicketEditBaseComponent {
	@Input() public ticketType: TicketType;
	@Input() public ticketRole: Role;
	@Input() public isComplete: boolean;
	@Input() public predecessorPreview: boolean;
	@Input() public etc: EditTicketsCombined;
	@Input() public isStarted: boolean;

	private getTicketType() {
		// TODO TP-3118:  Un-comment this when fixing TP-3118
		/*
		if (!this.ticketType) {
			return TicketType.Task;
		}
		*/
		return this.ticketType;
	}

	// Compute a style property based on ticketType
	get ticketStyle() {
		// return 'ticket-thumbnail' for all types, and optionally
		// append a second type specific class for milestones and
		// constraints
		const requiredString = 'ticket-thumbnail';
		const optionalString = !(this.getTicketType() === TicketType.Task)
			? requiredString + '--' + this.getTicketType()
			: '';
		const previewTypeString =
			this.predecessorPreview && this.getTicketType() === TicketType.Milestone
				? 'preview-milestone'
				: this.predecessorPreview && this.getTicketType() !== TicketType.Milestone
				? 'predecessor-preview'
				: '';
		return `${requiredString} ${optionalString} ${previewTypeString}`;
	}

	get isAssigned(): boolean {
		return this.etc ? this.etc.data.constraintState === CONSTRAINT_ACCEPTANCE_STATE.ASSIGNED : false;
	}

	get parsedTicketColor() {
		return this.ticketRole ? this.ticketRole.view.color : '#000000';
	}

	get assignedColor(): string {
		return this.etc.data.assignedProjectMemberRole
			? this.etc.data.assignedProjectMemberRole.view.color
			: '#000000';
	}

	get hasDarkColor(): boolean {
		return colorIsDark(this.parsedTicketColor);
	}
}
